import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '@uniqcamp/shared';
import { canAccessPrincipalFeatures } from '../utils/roles';
import { useFeatureAccess } from '../hooks/useFeatureAccess';

const Meetings: React.FC = () => {
  const navigate = useNavigate();
  const user = authService.getStoredUser();
  const isPrincipal = user && canAccessPrincipalFeatures(user.role);
  const { canView, loading: featureLoading } = useFeatureAccess('meetings');

  React.useEffect(() => {
    if (featureLoading) return;
    if (!isPrincipal && !canView) navigate('/', { replace: true });
  }, [isPrincipal, canView, featureLoading, navigate]);

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" component="h1" fontWeight={600} sx={{ mb: 2 }}>
        Meetings
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Approve and view meeting requests from parents.
      </Typography>
    </Box>
  );
};

export default Meetings;
